export default {
	properties: [
		{
			text: 'Modelo',
			key: 'model_name',
			type: 'text',
			is_title: true,
		},
		{
			text: 'Nombre (listas y ABM)',
			key: 'name',
			type: 'text',
		},
		{
			text: 'Encabezado PDF (label)',
			key: 'label',
			type: 'text',
		},
		{
			text: 'Value resolver',
			key: 'value_resolver',
			type: 'text',
		},
	],
	singular_model_name_spanish: 'Opcion de columnas PDF',
	plural_model_name_spanish: 'Opciones de columnas PDF',
	create_model_name_spanish: 'Nueva Opcion de columnas PDF',
	text_delete: 'la',
}



